import React, { type ComponentProps } from 'react';
import { StyleSheet } from 'react-native';

import { Image } from '@garnish/media';

export const ModalImage = (props: ModalImageProps) => {
  const { imageUrl, style, ...rest } = props;

  return (
    <Image source={imageUrl} contentFit="contain" style={[styles.illustration, style]} {...rest} />
  );
};

// ─── Types ─────────────────────────────────────────────────────────────

type ModalImageProps = Readonly<{
  imageUrl?: ComponentProps<typeof Image>['source'];
}> &
  ComponentProps<typeof Image>;

// ─── Styles ────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  illustration: {
    width: 200,
    height: 200,
    alignSelf: 'center',
  },
});
